import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './OneLine.sass'

interface Props extends React.HTMLAttributes<HTMLSpanElement> {}

export default observer(function OneLine({ className, ...rest }: Props) {
  return <span className={cx(styles.root, className)} {...rest} />
})
